module.exports = __webpack_public_path__ + "img/kefu.e9d96bf2.png";